import { useState } from "react";
import { Card } from "src/components/card";
import { FormField } from "src/components/formfield";
import { Vendor } from "../types/vendor";

export function SearchControls({
    options,
    handleSubmit,
    loading,
}: {
    options: Vendor[];
    handleSubmit: (
        partnerSearch: string,
        customerSearch: string,
    ) => Promise<void>;
    loading: boolean | null;
}) {
    const [partner, setPartner] = useState<string>("ALL");
    const [customerCode, setcustomerCode] = useState<string>("");

    return (
        <Card customization="">
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit(partner, customerCode);
                }}
            >
                {/* Partner Select */}
                <fieldset className="fieldset mb-0">
                    <legend className="fieldset-legend text-xs font-medium text-gray-600">
                        Partner
                    </legend>
                    <div className="relative">
                        <select
                            className="select select-bordered input-sm w-full pl-3 pr-8"
                            value={partner}
                            onChange={(e) => setPartner(e.target.value)}
                        >
                            <option disabled>Select</option>
                            <option key="ALL" value="ALL">
                                All
                            </option>
                            {options?.map((o) => (
                                <option
                                    key={o.TrackingPartner}
                                    value={o.TrackingPartner}
                                >
                                    {o.DisplayName}
                                </option>
                            ))}
                        </select>
                    </div>
                </fieldset>

                <FormField
                    legend="Customer Code"
                    value={customerCode}
                    onChange={(e) => setcustomerCode(e.target.value)}
                    error=""
                ></FormField>

                <button
                    type="submit"
                    className="btn btn-primary btn-sm mt-2 w-full"
                >
                    {loading ? (
                        <span className="loading loading-spinner"></span>
                    ) : (
                        "Search"
                    )}
                </button>
            </form>
        </Card>
    );
}
